import { Dialog } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import "./UpgradeDialog.scss";
import {
  createZohoCustomer,
  createZohoSubscription,
  getSubscriptionPlans,
  paymentRequest,
  upgradeSubscription,
} from "../../services/subscriptionService";
import { useSelector } from "react-redux";
import UpgradeConfirmationDialog from "./UpgradeConfirmationDialog";
import UpgradeSuccessDialog from "./UpgradeSuccessDialog";
import UpgradeMessageDialog from "./UpgradeMessageDialog";
import { toastMessage } from "../../helper";
import { deleteUserAssociations } from "../../services/srmService";
import SubscriptionSuccessDialog from "./SubscriptionSuccessDialog";

const UpgradePlanDialog = (props: any) => {
  let { open, onClose } = props;
  const subscription = useSelector((state: any) => state.sub.subscription);
  const baseCurrency = "USD";
  const [interval, setInterval] = useState<any>(null);
  const [allPlans, setAllPlans] = useState<any>([]);
  const [currentPlanLevel, setCurrentPlanLevel] = useState<any>(0);
  const [subscriptionPlansList, setSubscriptionPlansList] = useState<any>([]);
  const [currectSubscription, setCurrectSubscription] = useState<any>({});
  const [upgradeObject, setUpgradeObject] = useState<any>({});
  const [openUpgradeConfirmationDialog, setOpenUpgradeConfirmationDialog] =
    useState<any>(false);
  const [openUpgradeSuccessDialog, setOpenUpgradeSuccessDialog] =
    useState<any>(false);
  const [openUpgradeMessageDialog, setOpenUpgradeMessageDialog] =
    useState<any>(false);
  const [
    openSubscriptionConfirmationDialog,
    setOpenSubscriptionConfirmationDialog,
  ] = useState<any>(false);
  const [openSubscriptionSuccessDialog, setOpenSubscriptionSuccessDialog] =
    useState<any>(false);
  const [loadingButtonCode, setLoadingButtonCode] = useState<string>("");

  const renderMultiLineDescription = (description: any) => {
    let parsedFeatures = [];
    try {
      const parsedJson = JSON.parse(description);
      if (parsedJson.features) {
        parsedFeatures = parsedJson.features.map(
          (feature: any) => feature.name
        );
      }
    } catch (e) {
      parsedFeatures = description.split("|");
    }
    const descriptionLines = parsedFeatures.map((part: any, index: any) => (
      <React.Fragment key={index}>
        <div className="grow shrink basis-0 h-12 px-3 py-4 bg-white justify-start items-center gap-2 flex">
          <img src="assets/icons/check.svg" alt=" " />
          <div className="text-neutral-800 text-sm font-normal font-['Proxima Nova'] leading-tight">
            {part}
          </div>
        </div>
      </React.Fragment>
    ));
    return <div>{descriptionLines}</div>;
  };

  const onClickUpgrade = (planCode: string, planId: string) => {
    if (
      subscription?.planCode &&
      !(
        subscription?.planCode.includes("basic") ||
        subscription?.planCode.includes("essential") ||
        subscription?.planCode.includes("advanced")
      )
    ) {
      setOpenUpgradeMessageDialog(true);
    } else if (planCode.includes("advanced")) {
      setOpenUpgradeMessageDialog(true);
    } else if (subscription?.status === "unsubscribed") {
      setUpgradeObject({
        planId,
        planCode,
      });
      setOpenSubscriptionConfirmationDialog(true);
      // addNewSubscription(planCode, planId);
    } else if (!subscription?.cardProvided) {
      toastMessage("Please provide card details before plan upgrade", "info");
    } else {
      setUpgradeObject({
        planId,
        planCode,
      });
      setOpenUpgradeConfirmationDialog(true);
    }
  };

  const addNewSubscription = (planCode: string, planId: string) => {
    setLoadingButtonCode(planCode);
    setOpenSubscriptionConfirmationDialog(false);
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "");
    let user =
      localStorage.getItem("user") &&
      JSON.parse(localStorage.getItem("user") || "");
    if (
      user?.owner &&
      user?.email?.length &&
      company?.name?.length &&
      company?.id
    ) {
      createZohoCustomer({
        email: user.email,
        companyName: company.name,
        companyId: company.id,
        planId,
        planCode,
        user: user.owner,
      }).then((customerRes) => {
        createZohoSubscription({
          companyId: company.id,
        }).then((subscriptionRes) => {
          deleteUserAssociations().then(() => {
            localStorage.clear();
            setOpenSubscriptionSuccessDialog(true);
          });
        });
      });
    }
  };

  const onClickConfirm = () => {
    setOpenUpgradeConfirmationDialog(false);
    setOpenUpgradeSuccessDialog(true);
    upgradeSubscription(upgradeObject).then((res: any) => {});
  };

  const onClickContinue = () => {
    setOpenUpgradeSuccessDialog(false);
    window.location.reload();
  };

  useEffect(() => {
    setCurrectSubscription(subscription);
  }, [subscription]);

  useEffect(() => {
    getSubscriptionPlans().then((res: any) => {
      if (res?.data?.plans?.length) {
        res.data.plans.forEach((eachPlan: any) => {
          const planLevel =
            eachPlan.custom_fields?.length && eachPlan.custom_fields[0].value
              ? parseInt(eachPlan.custom_fields[0].value)
              : 0;
          eachPlan.plan_level = planLevel;
        });
        setAllPlans(res.data.plans);
        if (subscription?.status === "unsubscribed") {
          setInterval("months");
        } else {
          res.data.plans.forEach((eachPlan: any) => {
            if (subscription?.planCode === eachPlan.plan_code) {
              setInterval(eachPlan.interval_unit);
            }
          });
        }
      }
    });
  }, []);

  useEffect(() => {
    if (
      (subscription?.planCode || subscription?.status === "unsubscribed") &&
      allPlans.length &&
      interval
    ) {
      if (subscription?.status === "unsubscribed") {
        setCurrentPlanLevel(-1);
      } else {
        allPlans.forEach((eachPlan: any) => {
          if (subscription?.planCode === eachPlan.plan_code) {
            setCurrentPlanLevel(eachPlan.plan_level);
          }
        });
      }
      setSubscriptionPlansList(
        allPlans.filter(
          (eachPlan: any) =>
            eachPlan.plan_code?.toString().includes("v1") &&
            eachPlan.interval_unit === interval
        )
      );
    }
  }, [subscription, allPlans, interval]);

  return (
    <Fragment>
      {open && (
        <div>
          <Dialog className="pw-dialog-upgrade-plan" open={true}>
            <div className="p-6 bg-gray-50 shadow flex-col justify-start items-center gap-6 inline-flex">
              <div className="self-stretch h-28 flex-col justify-center items-start gap-2 flex">
                <div className="self-stretch justify-between items-start inline-flex">
                  <div className="w-96 h-8 text-neutral-800 text-2xl font-bold font-['Proxima Nova']">
                    Hello,
                  </div>
                  <div className="cursor-pointer">
                    <CloseIcon
                      className="pw-color-close-attchments"
                      onClick={onClose}
                    />
                  </div>
                </div>
                <div className="self-stretch h-px border border-zinc-200"></div>
                {interval && (
                  <div className="flex mt-4 w-full justify-center">
                    <div className="flex flex-row color-white pw-primary-color border border-solid border-black rounded-l-full rounded-r-full">
                      <div
                        className={`px-8 py-2 rounded-l-full
                        ${
                          interval === "months"
                            ? "pw-primary-website-background-color text-white"
                            : "cursor-pointer"
                        }
                      `}
                        onClick={() => {
                          setInterval("months");
                        }}
                      >
                        Monthly
                      </div>
                      <div
                        className={`px-8 py-2 rounded-r-full 
                        ${
                          interval === "years"
                            ? "pw-primary-website-background-color text-white"
                            : "cursor-pointer"
                        }
                      `}
                        onClick={() => {
                          setInterval("years");
                        }}
                      >
                        Yearly
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="self-stretch justify-center gap-4 inline-flex">
                {subscriptionPlansList.map((plan: any) => (
                  <div
                    key={plan.plan_id}
                    className={`pw-max-w-50 grow shrink basis-0 pb-4 bg-white rounded-2xl shadow flex-col justify-start items-center inline-flex border-4
                      ${
                        subscription?.planCode === plan.plan_code
                          ? "pw-primary-border-color"
                          : "border-transparent"
                      }
                    `}
                  >
                    <div className="self-stretch px-2 pt-4 pb-2 bg-white rounded-2xl flex-col justify-start items-center gap-4 flex">
                      <div className="text-neutral-800 text-xl font-bold font-['Proxima Nova']">
                        {plan.name}
                      </div>
                      {plan.plan_code && plan.plan_code.includes("advanced") ? (
                        <div className="flex-row justify-center items-center gap-2 flex">
                          <div className="text-neutral-800 text-3xl font-semibold font-['Proxima Nova']">
                            Custom
                          </div>
                        </div>
                      ) : (
                        <div className="flex-row justify-center items-center gap-2 flex">
                          <div className="text-neutral-800 text-xl font-semibold font-['Proxima Nova']">
                            {baseCurrency}
                          </div>
                          <div className="text-neutral-800 text-3xl font-semibold font-['Proxima Nova']">
                            {plan.recurring_price}
                          </div>
                          <div className="text-slate-700 text-sm font-normal font-['Proxima Nova'] leading-tight">
                            per {plan.interval_unit.slice(0, -1)}
                          </div>
                        </div>
                      )}
                    </div>
                    {subscription?.planCode === plan.plan_code ? (
                      <div className="self-stretch px-8 py-3 bg-white justify-center items-start gap-2 inline-flex">
                        <div className="grow shrink basis-0 h-8 rounded justify-center items-center flex cursor-pointer">
                          <div className="w-full px-4 py-1 justify-center items-center gap-2 flex">
                            <div className="text-green-600 pw-bg-primary-300-color px-4 px-2 rounded text-sm font-bold font-['Proxima Nova']">
                              Current Plan
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="self-stretch px-8 py-3 bg-white justify-center items-start gap-2 inline-flex">
                        <div
                          className={`grow shrink basis-0 h-8 rounded justify-center items-center flex
                          ${
                            plan.plan_level > currentPlanLevel &&
                            (loadingButtonCode.length === 0 ||
                              loadingButtonCode !== plan.plan_code)
                              ? "cursor-pointer pw-primary-website-background-color"
                              : "pw-neutral-background-400"
                          }
                        `}
                          onClick={() => {
                            plan.plan_level > currentPlanLevel &&
                              loadingButtonCode.length === 0 &&
                              onClickUpgrade(plan.plan_code, plan.plan_id);
                          }}
                        >
                          <div className="w-full px-4 py-1 justify-center items-center gap-2 flex">
                            {loadingButtonCode.length == 0 ||
                            loadingButtonCode !== plan.plan_code ? (
                              <div className="text-white text-xs font-bold font-['Proxima Nova']">
                                {plan.plan_code &&
                                plan.plan_code.includes("advanced")
                                  ? "Contact Us"
                                  : subscription?.status !== "unsubscribed"
                                  ? "Upgrade"
                                  : "Subscribe"}
                              </div>
                            ) : (
                              <div className="text-white text-xs font-bold font-['Proxima Nova']">
                                <CircularProgress size={20} />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="self-stretch justify-center items-start inline-flex">
                      {renderMultiLineDescription(
                        plan.store_markup_description
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Dialog>
        </div>
      )}
      {openUpgradeConfirmationDialog && (
        <UpgradeConfirmationDialog
          open={openUpgradeConfirmationDialog}
          onClose={() => {
            setOpenUpgradeConfirmationDialog(false);
          }}
          onConfirm={onClickConfirm}
          type={"plan"}
        />
      )}
      {openUpgradeSuccessDialog && (
        <UpgradeSuccessDialog
          open={openUpgradeSuccessDialog}
          onContinue={onClickContinue}
          type={"plan"}
        />
      )}
      {openUpgradeMessageDialog && (
        <UpgradeMessageDialog
          open={openUpgradeMessageDialog}
          onClose={() => {
            setOpenUpgradeMessageDialog(false);
          }}
          fromUpgradePlanDialog={true}
        />
      )}
      {openSubscriptionConfirmationDialog && (
        <UpgradeConfirmationDialog
          open={openSubscriptionConfirmationDialog}
          onClose={() => {
            setOpenSubscriptionConfirmationDialog(false);
          }}
          onConfirm={() => {
            addNewSubscription(upgradeObject.planCode, upgradeObject.planId);
          }}
          type={"subscribe"}
        />
      )}
      {openSubscriptionSuccessDialog && (
        <SubscriptionSuccessDialog
          open={openSubscriptionSuccessDialog}
          onClose={() => {
            setOpenSubscriptionSuccessDialog(false);
          }}
        />
      )}
    </Fragment>
  );
};

export default UpgradePlanDialog;
